// @ts-nocheck
import React from 'react';
import styled from 'styled-components';

import { Row, Col } from 'crehana-ui/GridV2';
import ArrowRight from 'crehana-icons/ArrowRight';
import { white } from 'crehana-ui/styles/colors';
import useCollapse from 'crehana-react-hooks/useCollapse';

import Checks from './Checks';
import { Benefit } from '../types';

const ArrowWrapper = styled.span<{ isOpen: boolean }>`
  will-change: transform;
  transition: 0.3s;
  transform: rotate(${props => (props.isOpen ? '90deg' : '0deg')});
  width: 24px;
`;

const ToggleItem: React.FC<{
  children: React.ReactNode;
  indexChildren: number;
  benefit: Benefit;
  className?: string;
}> = ({ children, indexChildren, benefit, className }) => {
  const { getToggleProps, getCollapseProps, isOpen } = useCollapse({
    defaultOpen: false,
  });
  const isEven = Boolean((indexChildren + 1) % 2);

  return (
    <article
      className={`${
        isEven ? 'bg-base-main rounded-5' : ''
      } py-32 pl-32  ${className}`}
    >
      <header {...getToggleProps()} className="outline-none">
        <Row>
          <Col xs={12} sm={12} md={4} lg={4}>
            <p className="font-subtitle2 flex">
              <ArrowWrapper isOpen={isOpen} className="self-start">
                <ArrowRight size={14} color={white} />
              </ArrowWrapper>
              <span className="ml-8">{benefit.title}</span>
            </p>
          </Col>
          <Checks benefit={benefit} isOpen={isOpen} />
        </Row>
      </header>
      {children && <div {...getCollapseProps()}>{children}</div>}
    </article>
  );
};

export default ToggleItem;
